// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/variables.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UX Doc reference: https://www.figma.com/file/nCZHeqxQWYPxFwNyx3uyYg/Group-Overhaul---2022?node-id=13094%3A229162 */
/* The below magic numbers are from UX Document, which indicate the ratio of 'element width / wrapping box width' */

.SkeletonLoadingCards_loaderContainer__X\\+K5C {
    box-sizing: border-box;
    padding: 16px 24px 30px;
}

.SkeletonLoadingCards_flexWrapper__AtwbF {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.SkeletonLoadingCards_avatar__wwG6U {
    width: 42px;
    height: 42px;
}

.SkeletonLoadingCards_barWrapper__GxB6U {
    width: calc(100% - 66px); /* 66px for 'avatar 42px' + 'padding 24 px' */
    height: 42px;
}

.SkeletonLoadingCards_bodyBar__YtPYp {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]};
    width: 100%;
    height: 16px;
    margin-top: 16px;
}

.SkeletonLoadingCards_bodyDataFieldWrapper__6BN97 {
    display: flex;
    margin-top: 16px;
}

.SkeletonLoadingCards_bodyDataFieldWrapper__6BN97 > div:not(:last-of-type) {
    margin-right: 24px;
}

.SkeletonLoadingCards_bodyDataField__DqraO {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]};
    width: calc(100% * 110 / 656);
    height: 36px;
}

.SkeletonLoadingCards_bodyMain__xXyqm {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]};
    height: 240px;
    margin: 16px -24px 0;
}

.SkeletonLoadingCards_skeletonAvatar__llH4v {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]};
    border-radius: 50%;
    margin-right: 24px;
}

.SkeletonLoadingCards_skeletonBarWrapper__CyWrf {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.SkeletonLoadingCards_skeletonBarWrapper__CyWrf * {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]};
    height: 10px;
}

.SkeletonLoadingCards_skeletonBarOne__5wPqA {
    width: calc(100% * 294 / 542);
}

.SkeletonLoadingCards_skeletonBarTwo__Lvh6y {
    width: calc(100% * 249 / 542);
}

@media (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["endXS"]}) {
    .SkeletonLoadingCards_avatar__wwG6U {
        width: 36px;
        height: 36px;
    }

    .SkeletonLoadingCards_barWrapper__GxB6U {
        height: 36px;
    }

    .SkeletonLoadingCards_loaderContainer__X\\+K5C {
        margin-bottom: 14px;
        padding: 14px 16px;
    }

    .SkeletonLoadingCards_bodyMain__xXyqm {
        margin: 16px -16px 0;
    }

    .SkeletonLoadingCards_skeletonAvatar__llH4v {
        margin-right: 10px;
    }

    .SkeletonLoadingCards_skeletonBarOne__5wPqA {
        width: calc(100% * 160 / 242);
    }

    .SkeletonLoadingCards_skeletonBarTwo__Lvh6y {
        width: calc(100% * 134 / 242);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SkeletonLoadingCards/SkeletonLoadingCards.module.css"],"names":[],"mappings":"AAGA,qHAAqH;AACrH,mHAAmH;;AAEnH;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB,EAAE,6CAA6C;IACvE,YAAY;AAChB;;AAEA;IACI,wDAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wDAAqB;IACrB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,wDAAqB;IACrB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,wDAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,wDAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":["@value (color_142) from 'ui-connect/styles/colors.module.css';\n@value (endXS) from 'ui-connect/styles/variables.module.css';\n\n/* UX Doc reference: https://www.figma.com/file/nCZHeqxQWYPxFwNyx3uyYg/Group-Overhaul---2022?node-id=13094%3A229162 */\n/* The below magic numbers are from UX Document, which indicate the ratio of 'element width / wrapping box width' */\n\n.loaderContainer {\n    box-sizing: border-box;\n    padding: 16px 24px 30px;\n}\n\n.flexWrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.avatar {\n    width: 42px;\n    height: 42px;\n}\n\n.barWrapper {\n    width: calc(100% - 66px); /* 66px for 'avatar 42px' + 'padding 24 px' */\n    height: 42px;\n}\n\n.bodyBar {\n    background: color_142;\n    width: 100%;\n    height: 16px;\n    margin-top: 16px;\n}\n\n.bodyDataFieldWrapper {\n    display: flex;\n    margin-top: 16px;\n}\n\n.bodyDataFieldWrapper > div:not(:last-of-type) {\n    margin-right: 24px;\n}\n\n.bodyDataField {\n    background: color_142;\n    width: calc(100% * 110 / 656);\n    height: 36px;\n}\n\n.bodyMain {\n    background: color_142;\n    height: 240px;\n    margin: 16px -24px 0;\n}\n\n.skeletonAvatar {\n    background: color_142;\n    border-radius: 50%;\n    margin-right: 24px;\n}\n\n.skeletonBarWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n}\n\n.skeletonBarWrapper * {\n    background: color_142;\n    height: 10px;\n}\n\n.skeletonBarOne {\n    width: calc(100% * 294 / 542);\n}\n\n.skeletonBarTwo {\n    width: calc(100% * 249 / 542);\n}\n\n@media (max-width: endXS) {\n    .avatar {\n        width: 36px;\n        height: 36px;\n    }\n\n    .barWrapper {\n        height: 36px;\n    }\n\n    .loaderContainer {\n        margin-bottom: 14px;\n        padding: 14px 16px;\n    }\n\n    .bodyMain {\n        margin: 16px -16px 0;\n    }\n\n    .skeletonAvatar {\n        margin-right: 10px;\n    }\n\n    .skeletonBarOne {\n        width: calc(100% * 160 / 242);\n    }\n\n    .skeletonBarTwo {\n        width: calc(100% * 134 / 242);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color_142": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_142"]}`,
	"endXS": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["endXS"]}`,
	"loaderContainer": `SkeletonLoadingCards_loaderContainer__X+K5C`,
	"flexWrapper": `SkeletonLoadingCards_flexWrapper__AtwbF`,
	"avatar": `SkeletonLoadingCards_avatar__wwG6U`,
	"barWrapper": `SkeletonLoadingCards_barWrapper__GxB6U`,
	"bodyBar": `SkeletonLoadingCards_bodyBar__YtPYp`,
	"bodyDataFieldWrapper": `SkeletonLoadingCards_bodyDataFieldWrapper__6BN97`,
	"bodyDataField": `SkeletonLoadingCards_bodyDataField__DqraO`,
	"bodyMain": `SkeletonLoadingCards_bodyMain__xXyqm`,
	"skeletonAvatar": `SkeletonLoadingCards_skeletonAvatar__llH4v`,
	"skeletonBarWrapper": `SkeletonLoadingCards_skeletonBarWrapper__CyWrf`,
	"skeletonBarOne": `SkeletonLoadingCards_skeletonBarOne__5wPqA`,
	"skeletonBarTwo": `SkeletonLoadingCards_skeletonBarTwo__Lvh6y`
};
export default ___CSS_LOADER_EXPORT___;
